import React from 'react'
import { useTranslation } from 'react-i18next'

type mainTitleProps={
    title:string,
    hint?:string
}

export default function SubTitle({title,hint}:mainTitleProps) {
    const {t} = useTranslation();
  return (
    <h2 className='mb-3 capitalize text-Black font-bold text-[14px]'>{t(title)} {hint&&<span className='text-[12px] text-gray-400 font-semibold'>{`(${t(hint)})`}</span>}</h2>
  )
}
